import AppSettings from "@/modules/app-settings";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import UnitState from "@/modules/unit";
import { ConversationBuilderService } from "@/services/conversation-builder";
import { BuilderPageType } from "@/util/enum";
import { isGuid } from "commonui";
import { parseInt } from "lodash";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const ConversationBuilderRouteResolver = async function (to: Route, from: Route, next: Function) {
	const builderModule = getModule(ConversationBuilderState);
	const appSetting = getModule(AppSettings);
	builderModule.resetState();
	const unitModule = getModule(UnitState);
	if (
		[BuilderPageType.ContentInfo, BuilderPageType.ExposureInfo, BuilderPageType.MasterInfo].includes(
			to.params.pagetype as BuilderPageType
		) &&
		(to.params.pagetype !== BuilderPageType.MasterInfo
			? to.params.id && isGuid(to.params.id)
			: to.params.id
			? typeof parseInt(to.params.id) === "number"
			: true)
	) {
		to.params.id &&
			(await builderModule.fetchConversation({ id: to.params.id, type: to.params.pagetype as BuilderPageType }));

		if (!to.params.id && to.params.pagetype === BuilderPageType.MasterInfo) {
			const [entities, intents, styles] = await Promise.all([
				ConversationBuilderService.getCommonEntities(),
				ConversationBuilderService.getCommonIntents(),
				ConversationBuilderService.getInteractionStyles()
			]);
			builderModule.setCommonEntitiesIntentsAndStyles({ entities, intents, styles });
		}

		await builderModule.isVcsInternalUser();
		builderModule.getTestVoiceGenerationStatus(true);
		builderModule.getConversationVoiceGenerationStatus(true);
		if (to.params.id && !builderModule.masterTemplateId) {
			builderModule.setMasterTemplateId(parseInt(to.params.id));
		}
		await unitModule.fetchUnits({ details: false });
		appSetting.setNavigationCollapse(true);
		next();
	} else {
		next("/404");
	}
};
